import { Injectable } from '@angular/core';

import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';

import {CookieService} from 'ngx-cookie';
declare var DDP_ENV: any;

@Injectable({
  providedIn: 'root'
})
export class TransactionService {

    readonly baseURL = DDP_ENV.patientUrl;

    constructor(private _http: Http, private cookieService: CookieService) {}

    getAllTransactions(page, status, size, regExp) {
        console.log('Inside get Transaction');
        return this._http.get(this.baseURL + '/app/transactions?page=' + page + '&size=' + size + '&regexPattern=' + regExp , this.buildHeaders());
    }

    getTransactionByUserId(userid) {
        console.log('Inside get Transaction by UserId');
        return this._http.get(this.baseURL + '/app/transactions/physician/user/'+userid , this.buildHeaders());
    }

    getPhysicianTransactionByUserId(userid,fromDate,toDate, page,size) {
        console.log('Inside get Transaction by UserId');
        return this._http.get(this.baseURL + '/app/transactions/user/'+userid+'/range/'+fromDate+'/'+toDate+'/all?page='+page+'&size='+size, this.buildHeaders());
    }

    getTransactionByAppointmentNumber(reference) {
        console.log('Inside get Transaction by UserId');
        return this._http.get(this.baseURL + '/app/transactions/appointment/'+reference, this.buildHeaders());
    }

    /* Construct a common header */
    private buildHeaders(): any {
        const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
        return new RequestOptions({ headers: headers });
    }

}
